export default function validateLogin(values) {
  const errors = {}

  if (!values.username) {
    errors.username = 'UsernameRequired'
  } else if (/\s/g.test(values.username)) {
    errors.username = 'UsernameBlank'
  }

  if (!values.password) {
    errors.password = 'PasswordRequired'
  } else if (/\s/g.test(values.password)) {
    errors.password = 'PasswordBlank'
  } else if (values.password.length < 5) {
    errors.password = 'PasswordLength'
  }

  return errors
}
